import PlatformApi from '@/api/PlatformApi';

let cached = null;
let pending = null;

/**
 * Load public platform config once per session (cached).
 *
 * @returns {Promise<{ platform_signup_enabled: boolean, default_account_slug: string }>}
 */
export function loadPlatformConfig() {
  if (cached) {
    return Promise.resolve(cached);
  }

  if (pending) {
    return pending;
  }

  pending = PlatformApi.getConfig()
    .then((response) => {
      cached = response.data?.data || {
        platform_signup_enabled: true,
        default_account_slug: 'webwalker',
      };
      return cached;
    })
    .catch(() => {
      cached = {
        platform_signup_enabled: true,
        default_account_slug: 'webwalker',
      };
      return cached;
    })
    .finally(() => {
      pending = null;
    });

  return pending;
}

/** @internal test helper */
export function resetPlatformConfigCache() {
  cached = null;
  pending = null;
}
